import React from "react";
import { Route, Routes } from "react-router-dom";
import GoalLandingView from "../../views/appraisal/goalManagement/GoalLandingView";
import QuarterLandingView from "../../views/appraisal/quarterManagement/QuarterLandingView";
import Goal from "../../views/L&D/Appraisal/golas/Goal";
import Index from "../../views/L&D/Appraisal/Index";
import AddGoals from "../../views/appraisal/goalManagement/AddGoal";
import KraLandingView from "../../views/appraisal/methods/KraLanding";
import AppraisalAdminOperations from "../../views/appraisal/adminOperations/AppraisalAdminOperations";
import ManagerUserListingLanding from "../../views/appraisal/evaluation/addEvaluationSelf/ManagerUserListingLanding";

const AppraisalManagementRouter = () => {
  return (
    <Routes>
      <Route path="goal" element={<GoalLandingView />} />
      <Route path="quarter" element={<QuarterLandingView />} />
      <Route path="appraisal" element={<Index />} />
      <Route path="add-goal" element={<AddGoals />} />
      <Route path="kra" element={<KraLandingView />} />
      <Route path="operations" element={<AppraisalAdminOperations />} />
      <Route path="appraisal-users" element={<ManagerUserListingLanding />} />

    </Routes>
  );
};

export default AppraisalManagementRouter;
